import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { UiProgress } from "../AdminLayout/NProgress";
import {
  Button,
  Dropdown,
  Flex,
  FloatButton,
  Input,
  Layout,
  Switch,
  theme,
  Tooltip,
} from "antd";
import { SideNav } from "./SideNav";
import { useDispatch, useSelector } from "react-redux";
import { uiCollapsedSidebar, uiSetToogleTheme } from "../../actions/ui";
import HeaderNav from "./HeaderNav";
import {
  AppstoreOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MoonOutlined,
  PoweroffOutlined,
  SettingOutlined,
  SunOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import { FooterNav } from "./FooterNav";
import { authStartLogout } from "../../actions/auth";
import { NotificationCenter } from "./NotificationCenter";

const { Content } = Layout;
const keys_usermenu = {
  configuracion: "configuracion",
  cerrarsesion: "cerrarsesion",
};
const menu_user = [
  {
    label: "Configuraciones de la cuenta",
    key: keys_usermenu.configuracion,
    icon: <SettingOutlined />,
  },
  {
    label: "Cerrar sesión",
    key: keys_usermenu.cerrarsesion,
    icon: <PoweroffOutlined />,
  },
];

export const AppLayout = () => {
  const {
    token: { borderRadius },
  } = theme.useToken();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const { collapsedSidebar: collapsed, mytheme } = useSelector(
    (state) => state.ui,
  );
  const { activeUsuario } = useSelector((state) => state.auth);
  const isMobile = useMediaQuery({ maxWidth: 769 });
  const [navFill, setNavFill] = useState(false);
  const floatBtnRef = useRef(null);
  useEffect(() => {
    onCollapsed(isMobile);
  }, [isMobile]);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 5) {
        setNavFill(true);
      } else {
        setNavFill(false);
      }
    });
  }, []);

  const onCollapsed = (broken) => {
    dispatch(uiCollapsedSidebar(broken));
  };
  const handleUserMenuClick = (e) => {
    if (e.key === keys_usermenu.cerrarsesion) dispatch(authStartLogout());
  };
  return (
    <>
      <UiProgress isAnimating={isLoading} key={location.key} />
      <Layout
        style={{
          minHeight: "100vh",
          // backgroundColor: 'white',
        }}
      >
        <SideNav
          trigger={null}
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => onCollapsed(value)}
          //   onBreakpoint={(broken) => {
          //     onCollapsed(broken);
          //   }}
          style={{
            overflow: "auto",
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            background: "none",
            border: "none",
            transition: "all .2s",
          }}
        />
        <Layout
          style={
            {
              // background: 'none',
            }
          }
        >
          <HeaderNav
            style={{
              marginLeft: collapsed ? 0 : "200px",
              padding: "0 2rem 0 0",
              background: navFill ? "rgba(255, 255, 255, .5)" : "none",
              backdropFilter: navFill ? "blur(8px)" : "none",
              boxShadow: navFill ? "0 0 8px 2px rgba(0, 0, 0, 0.05)" : "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "sticky",
              top: 0,
              zIndex: 1,
              gap: 8,
              transition: "all .25s",
            }}
          >
            <Flex align="center">
              <Tooltip title={`${collapsed ? "Expand" : "Collapse"} Sidebar`}>
                <Button
                  type="text"
                  icon={
                    collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
                  }
                  onClick={() => onCollapsed(!collapsed)}
                  style={{
                    fontSize: "16px",
                    width: 64,
                    height: 64,
                  }}
                />
              </Tooltip>
              <Input.Search
                placeholder="search"
                style={{
                  width: isMobile ? "100%" : "400px",
                  marginLeft: isMobile ? 0 : ".5rem",
                }}
                size="middle"
              />
            </Flex>
            <Flex align="center" gap="small">
              <Tooltip title="Apps">
                <Button icon={<AppstoreOutlined />} type="text" size="large" />
              </Tooltip>
              <Tooltip title="Messages">
                <NotificationCenter />
              </Tooltip>
              <Tooltip title="Theme">
                <Switch
                  className=" hidden sm:inline py-1"
                  checkedChildren={<MoonOutlined />}
                  unCheckedChildren={<SunOutlined />}
                  checked={mytheme === "light" ? true : false}
                  onClick={() => dispatch(uiSetToogleTheme())}
                />
              </Tooltip>
              <Dropdown
                menu={{ items: menu_user, onClick: handleUserMenuClick }}
                trigger={["click"]}
              >
                <Flex>
                  {activeUsuario?.image ? (
                    <img
                      src="/me.jpg"
                      alt="user profile photo"
                      height={36}
                      width={36}
                      style={{ borderRadius, objectFit: "cover" }}
                    />
                  ) : (
                    <Button icon={<UserOutlined />} type="text" size="large" />
                  )}
                </Flex>
              </Dropdown>
            </Flex>
          </HeaderNav>
          <Layout>
            <Content
              style={{
                margin: `0 0 0 ${collapsed ? 0 : "200px"}`,
                // background: '#ebedf0',
                borderRadius: collapsed ? 0 : borderRadius,
                transition: "all .25s",
                padding: "24px 32px",
                minHeight: 360,
              }}
            >
              {/* <TransitionGroup>
                <SwitchTransition>
                  <CSSTransition
                    key={`css-transition-${location.key}`}
                    nodeRef={nodeRef}
                    onEnter={() => {
                      setIsLoading(true);
                    }}
                    onEntered={() => {
                      setIsLoading(false);
                    }}
                    timeout={300}
                    classNames="bottom-to-top"
                    mountOnEnter
                    unmountOnExit={false}
                  >
                    <div ref={nodeRef} style={{ background: "none" }}> */}
              <Outlet />
              {/* </div>
                  </CSSTransition>
                </SwitchTransition>
              </TransitionGroup> */}
              <div ref={floatBtnRef}>
                <FloatButton.BackTop />
              </div>
            </Content>
          </Layout>

          <FooterNav
            style={{
              textAlign: "center",
              marginLeft: collapsed ? 0 : "200px",
              background: "none",
            }}
          />
        </Layout>
      </Layout>
    </>
  );
};
